export interface IuserModel{
  id:string;
  name:string;
  //title:string;
  app_token:string;
  companyid:string;
  companyname:string;
  companytel:string;
  //companytelext:string;
  //cellphone:string;
  email:string;
  //pictureurl:string;
  receunitid: string;
  receunitname: string;
  recemanid: string;
  recemanname: string;
  //accessToken: string;
}

export class userModel implements IuserModel{
  public id:string = "";
  public name:string = "";
  //public title:string = "";
  public app_token:string = "";
  public loginToken: string = "";
  public companyid:string = "";
  public companyname:string = "";
  public companytel:string = "";
  //public companytelext:string = "";
  //public cellphone:string = "";
  public email:string = "";
  //public pictureurl:string = "";
  public receunitid: string = "";
  public receunitname: string = "";
  public recemanid: string = "";
  public recemanname: string = "";
  //public accessToken: string = "";

  public transTo(value:any):userModel
  {
    this.id = value.id;
    this.name = value.name;
    //this.title = value.title;
    this.app_token = value.app_token;
    this.loginToken = value.loginToken;
    this.companyid = value.companyid;
    this.companyname = value.companyname;
    this.companytel=value.companytel;
    //this.companytelext=value.companytelext;
    //this.cellphone=value.cellphone;
    this.email=value.email;
    //this.pictureurl=value.pictireuel;
    this.receunitid=value.receunitid;
    this.receunitname=value.receunitname;
    this.recemanid=value.recemanid;
    this.recemanname=value.recemanname;
    //this.accessToken=value.accessToken;

    return this;
  }
  public toDBObject():IuserModel
  {
    return{
      id:this.id,
      name:this.name,
      //title:this.title,
      app_token:this.app_token,
      companyid:this.companyid,
      companyname:this.companyname,
      companytel:this.companytel,
      //companytelext:this.companytelext,
      //cellphone:this.cellphone,
      email:this.email,
      //pictureurl:this.pictureurl,
      receunitid:this.receunitid,
      receunitname:this.receunitname,
      recemanid:this.recemanid,
      recemanname:this.recemanname,
      //accessToken:this.accessToken
    };
  }
}
